import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardSkeletonComponent } from './card-skeleton.component';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [CardSkeletonComponent],
  imports: [
    CommonModule,
    IonicModule,
  ],
  exports: [CardSkeletonComponent]
})
export class CardSkeletonModule { }
